import React from 'react';
import style from './style.less';
const Placeholder = (props) => <span className={style.empty}>{props.text}</span>;
Placeholder.defaultProps = {
    text: '--',
};
export default Placeholder;
